import _regeneratorRuntime from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/codebuild/output/src173603427/src/mvptribe/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { initPjs } from "tsparticles-particles.js";
import { loadAngleUpdater } from "tsparticles-updater-angle";
import { loadBaseMover } from "tsparticles-move-base";
import { loadCircleShape } from "tsparticles-shape-circle";
import { loadColorUpdater } from "tsparticles-updater-color";
import { loadExternalAttractInteraction } from "tsparticles-interaction-external-attract";
import { loadExternalBounceInteraction } from "tsparticles-interaction-external-bounce";
import { loadExternalBubbleInteraction } from "tsparticles-interaction-external-bubble";
import { loadExternalConnectInteraction } from "tsparticles-interaction-external-connect";
import { loadExternalGrabInteraction } from "tsparticles-interaction-external-grab";
import { loadExternalPauseInteraction } from "tsparticles-interaction-external-pause";
import { loadExternalPushInteraction } from "tsparticles-interaction-external-push";
import { loadExternalRemoveInteraction } from "tsparticles-interaction-external-remove";
import { loadExternalRepulseInteraction } from "tsparticles-interaction-external-repulse";
import { loadImageShape } from "tsparticles-shape-image";
import { loadLifeUpdater } from "tsparticles-updater-life";
import { loadLineShape } from "tsparticles-shape-line";
import { loadOpacityUpdater } from "tsparticles-updater-opacity";
import { loadOutModesUpdater } from "tsparticles-updater-out-modes";
import { loadParallaxMover } from "tsparticles-move-parallax";
import { loadParticlesAttractInteraction } from "tsparticles-interaction-particles-attract";
import { loadParticlesCollisionsInteraction } from "tsparticles-interaction-particles-collisions";
import { loadParticlesLinksInteraction } from "tsparticles-interaction-particles-links";
import { loadPolygonShape } from "tsparticles-shape-polygon";
import { loadSizeUpdater } from "tsparticles-updater-size";
import { loadSquareShape } from "tsparticles-shape-square";
import { loadStarShape } from "tsparticles-shape-star";
import { loadStrokeColorUpdater } from "tsparticles-updater-stroke-color";
import { loadTextShape } from "tsparticles-shape-text";
export function loadSlim(_x) {
  return _loadSlim.apply(this, arguments);
}

function _loadSlim() {
  _loadSlim = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(engine) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return loadBaseMover(engine);

          case 2:
            _context.next = 4;
            return loadParallaxMover(engine);

          case 4:
            _context.next = 6;
            return loadExternalAttractInteraction(engine);

          case 6:
            _context.next = 8;
            return loadExternalBounceInteraction(engine);

          case 8:
            _context.next = 10;
            return loadExternalBubbleInteraction(engine);

          case 10:
            _context.next = 12;
            return loadExternalConnectInteraction(engine);

          case 12:
            _context.next = 14;
            return loadExternalGrabInteraction(engine);

          case 14:
            _context.next = 16;
            return loadExternalPauseInteraction(engine);

          case 16:
            _context.next = 18;
            return loadExternalPushInteraction(engine);

          case 18:
            _context.next = 20;
            return loadExternalRemoveInteraction(engine);

          case 20:
            _context.next = 22;
            return loadExternalRepulseInteraction(engine);

          case 22:
            _context.next = 24;
            return loadParticlesAttractInteraction(engine);

          case 24:
            _context.next = 26;
            return loadParticlesCollisionsInteraction(engine);

          case 26:
            _context.next = 28;
            return loadParticlesLinksInteraction(engine);

          case 28:
            _context.next = 30;
            return loadCircleShape(engine);

          case 30:
            _context.next = 32;
            return loadImageShape(engine);

          case 32:
            _context.next = 34;
            return loadLineShape(engine);

          case 34:
            _context.next = 36;
            return loadPolygonShape(engine);

          case 36:
            _context.next = 38;
            return loadSquareShape(engine);

          case 38:
            _context.next = 40;
            return loadStarShape(engine);

          case 40:
            _context.next = 42;
            return loadTextShape(engine);

          case 42:
            _context.next = 44;
            return loadLifeUpdater(engine);

          case 44:
            _context.next = 46;
            return loadOpacityUpdater(engine);

          case 46:
            _context.next = 48;
            return loadSizeUpdater(engine);

          case 48:
            _context.next = 50;
            return loadAngleUpdater(engine);

          case 50:
            _context.next = 52;
            return loadColorUpdater(engine);

          case 52:
            _context.next = 54;
            return loadStrokeColorUpdater(engine);

          case 54:
            _context.next = 56;
            return loadOutModesUpdater(engine);

          case 56:
            _context.next = 58;
            return initPjs(engine);

          case 58:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _loadSlim.apply(this, arguments);
}